import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Login } from 'src/app/model/login.model';
import { map, tap } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  titleCard: string = 'Pour se connecter';
  userForm!: FormGroup;
  isnotLogged!: boolean;
  inValid!: boolean;
  logInValid!: boolean;
  pwdInvalid!: boolean;
  constructor(
    private router: Router,
    private authservice: AuthService,
    private formBuilder: FormBuilder,
  ) {}

  token!: string;
  ngOnInit() {
    this.initForm();
  }

  onSubmitForm() {
    if (this.userForm.invalid) {
      const formValue = this.userForm.value;
      //// //console.log(formValue);
      if (
        formValue['username'] == undefined ||
        formValue['username'] == null ||
        formValue['username'] == ''
      ) {
        this.logInValid = true;
      }
      if (
        formValue['password'] == undefined ||
        formValue['password'] == null ||
        formValue['password'] == ''
      ) {
        this.pwdInvalid = true;
      }

      this.inValid = true;

      setTimeout(() => {
        this.inValid = false;
        this.logInValid = false;
        this.pwdInvalid = false;
      }, 10000);
    } else {
      //// //console.log(this.userForm.value);
      const formValue = this.userForm.value;
      const newUser2 = new Login(formValue['username'], formValue['password']);

      this.authservice
        .login(newUser2)
        .pipe(
          map((response) => {
            //// //console.log(response.token);
            if (response.status == 500) {
              this.isnotLogged = true;
            }

            if (response.logged === true) {
              sessionStorage.setItem('token', response.token);
              sessionStorage.setItem('logged', response.logged);
              sessionStorage.setItem(
                'user',
                JSON.stringify(response.beneficiary),
              );
              sessionStorage.setItem('loading', '0');

              this.authservice.getDashboard().subscribe({
                next: (data) => {
                  // console.log('Dashboard chargé après login', data)
                },
                error: (err) => {
                  console.error('Erreur lors du chargement du dashboard', err);
                },
              });
            } else {
              // alert('Login ou mot de passe incorrecte');
              // window.location.reload();
            }
          }),
        )
        .subscribe();
    }
  }
  initForm() {
    this.userForm = this.formBuilder.group({
      username: [null, Validators.required],
      password: [null, Validators.required],
    });
  }
}
